import { Component, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BrowseComponent } from 'src/app/shared/components/browse/browse.component';
import { DataGridColumn } from 'src/app/shared/components/datagrid/datagrid-core.component';
import { Logistica } from 'src/app/model/logistica/logistica';
import { LogisticaDataService } from 'src/app/core/services/logistica-crud.service';
import { LogisticaBrowseFilterComponent } from './logistica-browse-filter.component';
import { LogisticaSearchFilter } from 'src/app/model/logistica/logisticaSearchFilter';

@Component({
    selector: 'app-logistica-browse',
    templateUrl: '../../../shared/components/browse/browse.component.html',
    standalone: false
})
export class LogisticaBrowseComponent extends BrowseComponent<Logistica> {

  constructor(
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected router: Router, protected route: ActivatedRoute,
    protected modalService: NgbModal,
    protected dataService: LogisticaDataService) {

    super(componentFactoryResolver, router, route, modalService, dataService);

    this.title = 'Logística';
    this.componentFilter = LogisticaBrowseFilterComponent;
    this.browseRouterLink = '/logistica';
    this.manageRouterLink = '/logistica';
    this.globalMessage = '';
    this.showAdd = false;
    this.canDelete = false;
    this.canDeleteHandler = false;
    this.showExportExcel = true;

    this.filter = new LogisticaSearchFilter();
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.filter.returnTotalCount = true;

    this.columns.push(
      new DataGridColumn(
        'logisticaId', 'Nº',
        '[{"width": "70px","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'tipo', 'Tipo',
        '[{"width": "90px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'estado', 'Estado',
        '[{"width": "90px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'matricula', 'Matrícula',
        '[{"width": "80px", "textAlign": "center", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'numChassis', 'Nº Chassis',
        '[{"width": "90px", "textAlign": "center", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataRecolha', 'Recolha',
        '[{"width": "110px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataEntrega', 'Entrega',
        '[{"width": "110px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'produto', 'Produto',
        '[{"width": "200px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'local', 'Local',
        '[{"width": "110px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'responsavel', 'Responsável',
        '[{"width": "180px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'email', 'Email',
        '[{"width": "180px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'telefone', 'Telefone',
        '[{"width": "100px", "textAlign": "left", "formatDate": false }]'
      ));
  }
}
